/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_bookmark__badge_electriccar1 = /** @type {(inputs: {}) => string} */ () => {
	return `Elektrisches Auto`
};

const en_bookmark__badge_electriccar1 = /** @type {(inputs: {}) => string} */ () => {
	return `Electric car`
};

const es_bookmark__badge_electriccar1 = /** @type {(inputs: {}) => string} */ () => {
	return `Coches eléctricos`
};

const fr_bookmark__badge_electriccar1 = /** @type {(inputs: {}) => string} */ () => {
	return `Voiture électrique`
};

const it_bookmark__badge_electriccar1 = /** @type {(inputs: {}) => string} */ () => {
	return `Auto elettriche`
};

const nl_bookmark__badge_electriccar1 = /** @type {(inputs: {}) => string} */ () => {
	return `Elektrische auto's`
};

const pt_bookmark__badge_electriccar1 = /** @type {(inputs: {}) => string} */ () => {
	return `Automóveis eléctricos`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const bookmark__badge_electriccar1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bookmark__badge_electriccar1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("bookmark__badge_electriccar1", locale)
	if (locale === "de") return de_bookmark__badge_electriccar1(inputs)
	if (locale === "en") return en_bookmark__badge_electriccar1(inputs)
	if (locale === "es") return es_bookmark__badge_electriccar1(inputs)
	if (locale === "fr") return fr_bookmark__badge_electriccar1(inputs)
	if (locale === "it") return it_bookmark__badge_electriccar1(inputs)
	if (locale === "nl") return nl_bookmark__badge_electriccar1(inputs)
	return pt_bookmark__badge_electriccar1(inputs)
};
export { bookmark__badge_electriccar1 as "bookmark__badge_electricCar" }